export const INBOX_SORT_OPTIONS = [
  'name_asc',
  'name_desc',
  'activity_newest',
  'activity_oldest',
] as const

export type InboxSortOption = typeof INBOX_SORT_OPTIONS[number]
export type InboxSection = 'unread' | 'read'
export type InboxSortPrefix = 'name' | 'activity'

export const SORT_DEFAULTS: Record<InboxSection, InboxSortOption> = {
  unread: 'activity_newest',
  read: 'name_asc',
}

export const SORT_PREFIX_BY_OPTION: Record<InboxSortOption, InboxSortPrefix> = {
  name_asc: 'name',
  name_desc: 'name',
  activity_newest: 'activity',
  activity_oldest: 'activity',
}

interface SortableCompany {
  id: number
  name?: string
  lastActivityAt?: string | null
  unreadNotifications?: number
}

type CompanyMap = Record<number, SortableCompany>

export function sortCompanyIds(
  ids: number[],
  companies: CompanyMap,
  sort: InboxSortOption
): number[] {
  const lower = (c: SortableCompany): string =>
    (c.name ?? '').toString().toLowerCase()
  const ts = (c: SortableCompany): number =>
    Date.parse(c.lastActivityAt ?? '') || 0
  const sorted = ids.map((id) => companies[id]).filter(Boolean)

  switch (sort) {
    case 'name_asc':
      sorted.sort((a, b) => lower(a).localeCompare(lower(b)) || a.id - b.id)
      break
    case 'name_desc':
      sorted.sort((a, b) => lower(b).localeCompare(lower(a)) || a.id - b.id)
      break
    case 'activity_newest':
      sorted.sort((a, b) => ts(b) - ts(a) || lower(a).localeCompare(lower(b)))
      break
    case 'activity_oldest':
      sorted.sort((a, b) => ts(a) - ts(b) || lower(a).localeCompare(lower(b)))
      break
  }

  return sorted.map((c) => c.id)
}
